export default __webpack_public_path__ + "static/media/DePaul.8e4c744d.jpg";